import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { MoreInfo, SessionBoxWrapper } from './style';
import { HtmlRaw, Icon, Text } from '../../../atoms';
import {
  formatActivityInfo,
  getSessionPlace,
  timestampToDate,
} from '../../../../utils/common';
import ButtonBox from './ButtonBox';
import { withMediaQueries } from '../../../../app/hoc/withMediaQueries';

const SessionBox = ({ mediaIsPhone, activity, ai, sessionId }) => {
  const [info, setInfo] = useState({});

  useEffect(() => {
    if (activity?.date) {
      setInfo(formatActivityInfo(activity));
    }
  }, [activity]);

  return (
    <SessionBoxWrapper>
      <div>
        <div className={mediaIsPhone ? '' : 'd-flex'}>
          <Text type="h2" mb={16} className={ai === 0 ? '' : 'section-title'}>
            {activity?.title}
          </Text>
          {activity?.registration?.is_registered && (
            <Text type="b3" mb={16} className="completed">
              Registrazione completata
              <Icon type="check" clickable={false} />
            </Text>
          )}
        </div>
        <Text type="b3" mb={32}>
          <HtmlRaw html={activity?.description} />
        </Text>
        <MoreInfo>
          <div>
            <Text type="h3" mb={8}>
              Luogo sessione
            </Text>
            <Text type="b3" mb={16} className="d-flex">
              {getSessionPlace(activity)}
              <Icon type="marker-pin-02" clickable={false} />
            </Text>
          </div>
          <div>
            <Text type="h3" mb={8}>
              Data sessione
            </Text>
            <Text type="b3" mb={16}>
              {timestampToDate(info?.tsStart)}
              <Icon type="calendar" clickable={false} />
            </Text>
          </div>
          <div>
            <Text type="h3" mb={8}>
              Ora sessione
            </Text>
            <Text type="b3" mb={16}>
              {activity?.start_time} - {activity?.end_time}
              <Icon type="clock" clickable={false} />
            </Text>
          </div>
        </MoreInfo>
      </div>
      <ButtonBox activity={activity} info={info} sessionId={sessionId} />
    </SessionBoxWrapper>
  );
};

SessionBox.propTypes = {
  mediaIsPhone: PropTypes.bool,
  activity: PropTypes.object,
  ai: PropTypes.number,
  sessionId: PropTypes.number,
};

export default withMediaQueries(SessionBox);
